/* ============================================================
   ROUTE RELAX LANDING — JS compartido entre las 12 secciones.
   Se carga una sola vez (ver layout/landing.liquid). Cada función
   verifica que sus elementos existan antes de operar, así una
   sección oculta/reordenada desde el customizer no rompe nada.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
  // (qty) para que el pedido lleve las unidades exactas (el proveedor de
  // fulfillment envía la cantidad) y el total quede en el precio del bundle.
  // Releasit lee el input[name="quantity"] del DOM al disparar COD.
  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  // btn trae directo data-bundle-variant-id/qty (CTA final, sin selector) o
  // data-fieldset apuntando al <fieldset> con los radios de bundle (hero y
  // oferta final), de donde se lee la opción marcada.
  window.routeRelaxTriggerCOD = function (btn) {
    var variantId = btn.getAttribute('data-bundle-variant-id');
    var qty = btn.getAttribute('data-bundle-qty');
    var fieldsetId = btn.getAttribute('data-fieldset');
    if (!variantId && fieldsetId) {
      var fs = document.getElementById(fieldsetId);
      var checked = fs ? fs.querySelector('input[type="radio"]:checked') : null;
      if (checked) {
        variantId = checked.getAttribute('data-variant-id');
        qty = checked.getAttribute('data-qty');
      }
    }
    setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var releasitBtn = findReleasitButton();
      if (releasitBtn) { releasitBtn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };

  // ---------- countdown: 3h por cliente, se reinicia al expirar ----------
  // Vive en la sección "Countdown" (#clock); no-op si esa sección está oculta.
  var KEY = 'rr_countdown_end';
  var THREE_H = 3 * 60 * 60 * 1000;
  function getEnd() {
    try {
      var v = localStorage.getItem(KEY);
      var end = v ? parseInt(v, 10) : 0;
      if (!end || end <= Date.now()) {
        end = Date.now() + THREE_H;
        localStorage.setItem(KEY, String(end));
      }
      return end;
    } catch (e) { return Date.now() + THREE_H; }
  }
  function initCountdown() {
    var clockEl = document.getElementById('clock');
    if (!clockEl) return;
    var end = getEnd();
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        try {
          end = Date.now() + THREE_H;
          localStorage.setItem(KEY, String(end));
        } catch (e) { end = Date.now() + THREE_H; }
      }
      diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      function p(n) { return String(n).padStart(2, '0'); }
      clockEl.textContent = p(h) + ':' + p(m) + ':' + p(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  // ---------- hero: miniaturas clicables actualizan la foto principal ----------
  // Vive en la sección "Hero" (#galleryMain / .thumb); no-op si está oculta.
  function initGallery() {
    var main = document.getElementById('galleryMain');
    if (!main) return;
    var thumbs = main.parentElement ? main.parentElement.querySelectorAll('.thumb') : [];
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var bg = t.getAttribute('data-full-bg');
        var label = t.getAttribute('data-full-label');
        var img = t.getAttribute('data-full-img');
        if (img) {
          main.style.background = 'none';
          main.innerHTML = '<img src="' + img + '" alt="" loading="lazy">';
        } else {
          main.innerHTML = label || '';
          main.style.background = bg || '';
        }
        thumbs.forEach(function (c) { c.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  // ---------- sincronizar precio mostrado con el bundle seleccionado ----------
  // Vive en "Hero" y "Oferta final" (#bundles / #bundles2); no-op si faltan.
  function wireBundleFieldset(fieldsetId, priceElId) {
    var fs = document.getElementById(fieldsetId);
    if (!fs) return;
    fs.addEventListener('change', function (e) {
      var priceEl = document.getElementById(priceElId);
      if (priceEl && e.target.dataset.price) priceEl.textContent = e.target.dataset.price;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initGallery();
    wireBundleFieldset('bundles', 'ctaPrice');
    wireBundleFieldset('bundles2', 'ctaPrice2');
  });
})();
